import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { VulnerabilitiesComponent } from './vulnerabilities/vulnerabilities.component';
import { VulnerabilitiesService } from '@app/pages/services/vulnerabilities.service';
import { RouterLink } from '@angular/router';

@NgModule({
    declarations: [PageNotFoundComponent, VulnerabilitiesComponent],
    imports: [CommonModule, SharedModule, RouterLink],
    providers: [VulnerabilitiesService],
})
export class PagesModule {}
